/* eslint-disable react/no-danger */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  IconButton,
  Slide,
  Typography,
} from '@mui/material';
import {
  findAnnotaionsFromId,
  getHeightMegduSlov,
  selectTheme,
} from '../../utils/utils';
import { AnnotaionDto, LectionSlideDto } from '../../dto/LectionImageDto';
import { LECTION_ROUTE } from '../../constant/routes';
import { DialogAnnotation } from './DialogAnnotation';

interface Props {
  slideNum: number;
  curTheme: number;
  dto: LectionSlideDto[];
  open: boolean;
  scrollPostion: number;
  fontSize: string;
  onClose: (e: any) => void;
}

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>
    // eslint-disable-next-line react/jsx-props-no-spreading
  ) => <Slide direction="up" ref={ref} {...props} />
);

export const DialogOnlyText: FunctionComponent<Props> = ({
  slideNum,
  curTheme,
  dto,
  open,
  scrollPostion,
  fontSize,
  onClose,
}) => {
  const { section, lectionId } = useParams();
  const navigate = useNavigate();

  const [lect, setLect] = useState('');

  const [scrollPosition, setScrollPosition] = useState(scrollPostion);

  const [load, setLoad] = useState(false);

  const handleClose = (e: any) => {
    setLoad(false);
    onClose(e);
  };

  const [annotationDto, setAnnotationDto] = useState<AnnotaionDto>({
    id: '',
    title: '',
    text: '',
  });

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    navigate(`${LECTION_ROUTE}/${section}/${lectionId}`);
  };

  const showPopup = (id: string) => {
    const annotation: AnnotaionDto = findAnnotaionsFromId(id, dto[0]);
    if (annotation.id !== '') {
      setAnnotationDto(annotation);
      handleOpenDialog();
    }
  };

  useEffect(() => {
    if (open) {
      setLect(
        dto[0].text
          .replaceAll(
            'linkColor',
            selectTheme(dto[0].selectTextColor, curTheme, 1)
          )
          .replaceAll(
            'background-color:#e0e0e0; border: 1px solid #e0e0e0',
            `background-color:${selectTheme(
              dto[0].backgroundDiv,
              curTheme,
              1
            )}; border: 1px solid ${selectTheme(
              dto[0].backgroundDiv,
              curTheme,
              1
            )}`
          )
      );
      setLoad(true);
      setScrollPosition(scrollPostion);
    } else {
      setLect('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (load) {
      const href = window.location.href.substring(
        window.location.href.lastIndexOf('#') + 1
      );
      if (
        !href.includes('update_') &&
        !href.includes('question_') &&
        !href.includes('more_')
      ) {
        if (window.location.href.lastIndexOf('#') > 0) {
          const divScro = document.getElementById(
            'dialogAllTextSlide'
          ) as HTMLDivElement;
          divScro?.scrollTo(0, scrollPosition);
        }
        setLect(
          dto[0].text
            .replaceAll(
              'linkColor',
              selectTheme(dto[0].selectTextColor, curTheme, 1)
            )
            .replaceAll(
              `id="${href}" style="background-color: undefined;`,
              `id="${href}" style="background-color: ${selectTheme(
                dto[0].selectBackgroundColor,
                curTheme,
                1
              )};`
            )
            .replaceAll(
              'background-color:#e0e0e0; border: 1px solid #e0e0e0',
              `background-color:${selectTheme(
                dto[0].backgroundDiv,
                curTheme,
                1
              )}; border: 1px solid ${selectTheme(
                dto[0].backgroundDiv,
                curTheme,
                1
              )}`
            )
        );
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, curTheme]);

  useEffect(() => {
    if (open) {
      const href = window.location.href.substring(
        window.location.href.lastIndexOf('#') + 1
      );
      const isHref = window.location.href.includes('#');
      const divScro = document.getElementById(
        'dialogAllTextSlide'
      ) as HTMLDivElement;

      if (isHref && href.includes('question_')) {
        showPopup(href.replaceAll('question_', ''));
      }
      if (href.length > 15 && !href.includes('question_')) {
        if (isHref) {
          handleClose(divScro.scrollTop);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  useEffect(() => {
    const element = document.getElementById(`divider_${slideNum - 1}`);
    if (element !== null) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'auto', block: 'center' });
      }, 100);
    }
  }, [lect]);

  return (
    <div
      style={{
        background: selectTheme(dto[0].backgroundText, curTheme, -1),
      }}
    >
      <Dialog
        fullScreen
        open={open}
        sx={{
          background: selectTheme(dto[0].backgroundText, curTheme, -1),
        }}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <IconButton
          size="small"
          sx={{ position: 'fixed', right: 10, top: 10, zIndex: 9 }}
          onClick={onClose}
          disableRipple
        >
          <CloseIcon
            sx={{
              color: selectTheme('#000000;#848d95', curTheme, 1),
            }}
          />
        </IconButton>
        <DialogContent
          id="dialogAllTextSlide"
          sx={{ background: selectTheme(dto[0].backgroundText, curTheme, -1) }}
          dividers={false}
        >
          <div
            style={{
              userSelect: 'none',
              WebkitUserSelect: 'none',
              WebkitTextSizeAdjust: '100%',
              background: selectTheme(dto[0].backgroundText, curTheme, -1),
            }}
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontSize,
                overflow: 'auto',
                fontWeight: '400',
                textAlign: 'left',
                color: selectTheme(dto[0].textColor, curTheme, -1),
                lineHeight: getHeightMegduSlov(fontSize),
              }}
              component="html"
            >
              <div dangerouslySetInnerHTML={{ __html: lect }} />
            </Typography>
          </div>
        </DialogContent>
      </Dialog>
      <DialogAnnotation
        curTheme={curTheme}
        textColor={dto[0].textColor}
        backgrounColor={dto[0].backgroundImage}
        open={openDialog}
        fontSize={fontSize}
        title={annotationDto.title}
        text={annotationDto.text}
        onClose={handleCloseDialog}
      />
    </div>
  );
};
